export const checkBrowser = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  if (otherApp()) {
    return otherApp()
  }
  if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
    return 'WECHAT'
  }
  if (isAlipay()) {
    return 'ALIPAY'
  }
  // 判断是否在华为快应用环境
  if (ua.indexOf('huawei') > -1 && ua.indexOf('fastapp') > -1) {
    return 'HWQUICK'
  }

  return process.env.VUE_APP_NODE_ENV === 'test' || process.env.VUE_APP_NODE_ENV === 'development' ? 'WECHAT' : 'APP'
}

export const isPC = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  const Agents = ['Android', 'iPhone', 'webOS', 'BlackBerry', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  for (let item of Agents) {
    item = item.toLowerCase()
    if (ua.includes(item)) {
      return false
    }
  }
  return true
}
export const isWX = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  // 兼容其他渠道也是微信环境
  if (otherApp()) {
    return false
  }
  return ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger'
}
export const isAlipay = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/Alipay/i) && ua.match(/Alipay/i)[0] === 'alipay'
}
export const isAndroid = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1
}

export const isiOS = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('iphone') > -1 || ua.indexOf('mac') > -1
}

/** 通过链接参数channel判断其他渠道 */
export const otherApp = function () {
  const searchParams = location.href.split('?')[1]
  const channel = new URLSearchParams(searchParams).get('channel') || ''
  let storageChannel = ''
  if (!window.sessionStorage) {
    storageChannel = window.localStorage.getItem('query_channel') || ''
  } else {
    storageChannel = window.sessionStorage.getItem('query_channel') || ''
  }
  const obj = {
    EMSAPP: 'APP',
    CMBC: 'CMBAPP',
    YSF: 'YSFAPP',
    CHINAPOST: 'CHINAPOST',
    HWQUICK: 'HWQUICK',
    HWMEETIME: 'HWMEETIME',
    ICBC: 'ICBC',
    PSBC: 'PSBC',
    SWAN: 'SWAN',
    PING_AN_LIFE: 'PING_AN_LIFE',
    LLTAPP: 'LLTAPP',
    YSH: 'YSH',
    YOULIFE: 'YOULIFE',
    NANJPCNP: 'NANJPCNP',
    MVAGOV: 'MVAGOV',
    ICHAOZHOUAPP: 'ICHAOZHOUAPP',
    TODAYHEADLINES: 'TODAYHEADLINES',
    WECHAT_MINI_PROGRAM: 'WECHAT_MINI_PROGRAM'
  }
  if (channel) {
    const mergeChannel = obj[channel] || channel
    if (!window.sessionStorage) {
      window.localStorage.setItem('query_channel', mergeChannel)
    } else {
      window.sessionStorage.setItem('query_channel', mergeChannel)
    }
    return mergeChannel
  } else {
    if (storageChannel && storageChannel !== 'undefined') {
      return storageChannel
    } else {
      return false
    }
  }
}

/**
 * @Description: 判断当前环境是否微信
 * @params: type = 'wx' | 'wxWork' | 'wxMiniprogram' | 'aliApp' | 'aliMiniprogram'
 * @params: type取值说明: wx:微信，wxWork：企业微信，wxMiniprogram：微信小程序，ali：支付宝生活号，aliMiniprogram：支付宝小程序
 * @return: true-是当前环境，false-非传入的环境
 */
export function checkAppUA (type) {
  const isTenCent = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 // 判断是否微信UA
  const isWxWork = navigator.userAgent.toLowerCase().indexOf('wxwork') !== -1 // 判断是否企业微信UA
  const isAliPay = navigator.userAgent.toLowerCase().indexOf('alipay') !== -1 // 判断是否支付宝打开
  const isMiniProgram = navigator.userAgent.toLowerCase().indexOf('miniprogram') !== -1 // 判断是否小程序的web-view打开
  console.log('navigator.userAgent', navigator.userAgent)
  switch (type) {
    case 'wx':
      return isTenCent && !isWxWork
    case 'wxWork':
      return isWxWork
    case 'aliApp':
      return isAliPay
    case 'wxMiniprogram':
      return isTenCent && isMiniProgram
    case 'aliMiniprogram':
      return isAliPay && isMiniProgram
    default:
      return false
  }
}
